import { render, staticRenderFns } from "./KbInfoModal.vue?vue&type=template&id=9c9c2886&"
import script from "./KbInfoModal.vue?vue&type=script&lang=js&"
export * from "./KbInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports